import React, { forwardRef } from 'react';
import { shouldNotForwardThemeProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import aria from '@polestar/component-warehouse-react/helpers/accessibility/aria';
import styled from '@emotion/styled';
const Input = forwardRef((props, ref) => (React.createElement(StyledInput, { ...aria({
        disabled: props.disabled,
    }), ...props, ref: ref })));
Input.displayName = 'Input';
/**
 * @internal
 */
export default Input;
const StyledInput = styled('input', shouldNotForwardThemeProps) `
  background: none;
  border: none;
  color: inherit;
  width: 100%;

  &:focus {
    outline: none;
  }

  &::-ms-clear,
  &::-ms-reveal {
    display: none;
  }
`;
